import * as React from 'react';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import FilledInput from '@mui/material/FilledInput';
import IconButton from '@mui/material/IconButton';
import { PersonSearch } from '@mui/icons-material';
import { ethers } from "ethers";

function isValidUserInput(a){
  if (a.includes('.eth') || ethers.utils.isAddress(a)) {
    return true
  }
  return false
}

class AddressLookup extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
        this.state = {
            user_input: ""
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleClick() {
        this.props.setUserAddress(this.state.user_input);
    }

    onChange(value) {
        this.setState({
          user_input: value
        })
    }

    handleSelect() {
        this.setState({
          user_input: ''
        })
    }

    onKeyDown(e) {
        if (e.key === 'Enter'){
            this.handleClick();
        }
    }


    render() {
        return <FormControl sx={{ m: 1, width: '90%'}} variant="filled">
        <InputLabel htmlFor="filled-adornment-password">Polygon Address or ENS</InputLabel>
        <FilledInput
          id="filled-adornment-password"
          type="text"
          value={this.state.user_input}
          error={this.state.user_input !== "" && ! isValidUserInput(this.state.user_input)}
          placeholder={this.props.user_input}
          onChange={e => this.onChange(e.target.value)}
          onKeyDown={e => this.onKeyDown(e)}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="search"
                disabled={! isValidUserInput(this.state.user_input)}
                onClick={this.handleClick}
                edge="end"
              >
                <PersonSearch/>
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    }
}

export default AddressLookup